const interval = setInterval(() => {
  const designButton = document.querySelector('#customers_canvas_button');
  designButton.removeEventListener('click', openEditor)
  designButton.addEventListener('click', openEditor);
}, 100);

setTimeout(() => {
  clearInterval(interval);
}, 3000);

function openEditor(e){
    e.preventDefault(); 
    e.stopPropagation();
    console.log('!');
    let selectedVariantId = getSelectedVariantId();
    let quantity = getQuantity();
    window.location.search = "?view=customers-canvas-uif&variant=" + selectedVariantId + "&quantity=" + quantity;
    
    function getSelectedVariantId() {
    const _getFromForm = () => {
      const formElement = document.querySelector("form[action='/cart/add']");
      const formString = new URLSearchParams(new FormData(formElement)).toString();
      if (formString) {
        const urlSearchParams = new URLSearchParams(formString);
        const objData = Object.fromEntries(urlSearchParams.entries());
        if (objData && objData['id']) {
          return objData['id'];
        } else {
          return null;
        }
      } else {
        return null;
      }
    };
    const _getFromShopifyMeta = () => {
      return window.ShopifyAnalytics?.meta?.selectedVariantId || null;
    }
    const selectedVariantId = _getFromForm() || _getFromShopifyMeta();
    return selectedVariantId == null ? selectedVariantId : Number(selectedVariantId);
    };

    function getQuantity() {
    var qty = document.querySelector(".quantity__input")?.value;
    if (!qty) {
      qty = 1;
    }
    return qty;
    }
}